var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        "cancel-title": "Abbrechen",
        "hide-footer": "",
        "modal-class": "email-damage-record-assign-modal",
        size: "lg",
        title: _vm.modalTitle,
      },
      on: { hidden: _vm.resetModalState },
      model: {
        value: _vm.show,
        callback: function ($$v) {
          _vm.show = $$v
        },
        expression: "show",
      },
    },
    [
      _vm.isLoadingAssignments
        ? _c(
            "div",
            { staticClass: "email-damage-record-assign-modal__loading" },
            [_c("csp-loading-indicator")],
            1
          )
        : _c(
            "div",
            [
              _c(
                "div",
                { staticClass: "d-flex align-items-end mb-3" },
                [
                  _c("AppraisalAutocompleteInput", {
                    attrs: { "email-id": _vm.emailId },
                    on: { selected: _vm.onAppraisalSelected },
                  }),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      staticClass: "ml-2",
                      attrs: {
                        disabled: !_vm.selectedAppraisal || _vm.isAssigning,
                        variant: "primary",
                      },
                      on: { click: _vm.assign },
                    },
                    [_vm._v("\n                Verknüpfen\n            ")]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.assignments.length === 0
                ? _c("div", { staticClass: "text-muted" }, [
                    _vm._v(
                      "\n            Dieser E-Mail ist noch kein Gutachten zugeordnet.\n        "
                    ),
                  ])
                : _c("b-table", {
                    attrs: {
                      borderless: "",
                      fields: _vm.tableFields,
                      items: _vm.tableItems,
                      responsive: "",
                      striped: "",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "table-colgroup",
                        fn: function (scope) {
                          return _vm._l(scope.fields, function (field) {
                            return _c("col", {
                              key: field.key,
                              style: { width: field.width ?? "auto" },
                            })
                          })
                        },
                      },
                      {
                        key: "cell(actions)",
                        fn: function (row) {
                          return [
                            _c("div", { staticClass: "table-actions d-flex" }, [
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href: _vm.getAppraisalLink(
                                      row.item.vehicleDamageRecordId,
                                      row.item.damageRecordAppraisalId
                                    ),
                                    title: "Gutachten öffnen",
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass: "inticon-autoclaim_detail",
                                  }),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href: "#",
                                    title: "Zuordnung entfernen",
                                  },
                                  on: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                      return _vm.removeAssignment(
                                        row.item.assignment
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass: "inticon-autoclaim_loschen",
                                  }),
                                ]
                              ),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
            ],
            1
          ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }